var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-container cw-container-list",
      class: [
        "cw-container-colspan-" + _vm.colSpan,
        _vm.showEditMode && _vm.canEdit ? "cw-container-active" : ""
      ]
    },
    [
      _c(
        "div",
        {
          staticClass: "cw-container-content"
        },
        [
          _vm.showEditMode && _vm.canEdit
            ? _c(
                "header",
                {
                  staticClass: "cw-container-header"
                },
                [
                  _vm.blockedByAnotherUser
                    ? _c("studip-icon", {
                        attrs: {
                          shape: "lock-locked"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.container.attributes.title) +
                        " (" +
                        _vm._s(_vm.container.attributes.width) +
                        ")"
                    )
                  ]),
                  _vm._v(" "),
                  _vm.blockedByAnotherUser
                    ? _c(
                        "span",
                        {
                          staticClass: "cw-default-container-blocker-warning"
                        },
                        [
                          _vm._v(
                            "\n                | " +
                              _vm._s(
                                _vm.$gettextInterpolate(
                                  _vm.$gettext(
                                    "wird im Moment von %{ userName } bearbeitet"
                                  ),
                                  {
                                    userName: this.blockingUserName
                                  }
                                )
                              ) +
                              "\n            "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("courseware-container-actions", {
                    attrs: {
                      canEdit: _vm.canEdit,
                      container: _vm.container
                    },
                    on: {
                      editContainer: _vm.displayEditDialog,
                      deleteContainer: _vm.displayDeleteDialog,
                      sortBlocks: _vm.sortBlocks,
                      removeLock: _vm.displayRemoveLockDialog
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cw-block-wrapper",
              class: {
                "cw-block-wrapper-active": _vm.showEditMode
              }
            },
            [_vm._t("containerContent")],
            2
          ),
          _vm._v(" "),
          _vm.showEditDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textEditTitle,
                  confirmText: _vm.textEditConfirm,
                  confirmClass: "accept",
                  closeText: _vm.textEditClose,
                  closeClass: "cancel",
                  height: "430",
                  width: "680"
                },
                on: {
                  close: _vm.closeEdit,
                  confirm: _vm.storeContainer
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "dialogContent",
                      fn: function fn() {
                        return [_vm._t("containerEditDialog")]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showDeleteDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textDeleteTitle,
                  question: _vm.textDeleteAlert,
                  height: "180",
                  width: "380"
                },
                on: {
                  confirm: _vm.executeDelete,
                  close: _vm.closeDeleteDialog
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showRemoveLockDialog
            ? _c("studip-dialog", {
                attrs: {
                  title: _vm.textRemoveLockTitle,
                  question: _vm.textRemoveLockAlert,
                  height: "200",
                  width: "450"
                },
                on: {
                  confirm: _vm.executeRemoveLock,
                  close: function close($event) {
                    _vm.showRemoveLockDialog = false
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }